import React from 'react';

import { Helpers } from '../../core/src/helpers';
import { withProductPrice } from './product-price/with-product-price';
import { withError } from '../../shared/components/error-boundary';
import Tooltip from '../../shared/components/tooltip';
import ABTest from '../../abtest/components/abtest';

/**
 * Renders product special offers
 * With the the price HOC, offers assumers prices is being displayed and fetch
 * Not sure if there is every case where a product will be displayed with out the product-price component
 * However in that case the price info would not be availble and would need to be fetched
 * @param  {Object} options.product The product object with offers
 * @param  {Object} price}         The price object from the provided product
 */
const SpecialOffers = ({ children, maxOffers, product = {}, price, personData, withToolTip }) => {
    return (
        <ABTest experimentID="pstore-offers" ssrRender={true}>
            {data => {
                let { offers } = product;
                const { jTierDis, jPromMsg } = price;
                let { pStoreID } = personData;
                //default to gs if none provided, we dont default to gs in redux
                //because we dont want to include pStoreID=gs in urls since it's the default
                pStoreID = pStoreID || 'gs';
                //initialize offers if null or undefiend
                offers = offers || [];
                let showJProm = !!jPromMsg;

                let dynamicOffer = offers.reduce((result, offer, i) => {
                    try {
                        const isLast = offers.length - 1 === i;
                        //ignore empty bullets
                        if (!isLast && (offer.value === '' || offer.value === '<p></p>')) {
                            return result;
                        }
                        if (
                            isLast &&
                            /^save \$.* instantly$/i.test(offer.value) &&
                            (jPromMsg || '').trim() !== '' &&
                            (!offer.privateStoreOnly || offer.privateStoreOnly.includes(pStoreID))
                        ) {
                            showJProm = false;
                            result.push({ value: jPromMsg, type: 'jPromMsg' });
                            return result;
                        }
                    } catch (e) {
                        //pass
                    }

                    if (!offer.privateStoreOnly || (offer.privateStoreOnly || []).includes(pStoreID)) {
                        result.push(offer);
                    }

                    return result;
                }, []);

                if (maxOffers) {
                    dynamicOffer = dynamicOffer.slice(0, maxOffers);
                }
                try {
                    //if AB test offers included display them
                    if (data && (data.skus || []).includes(product.sku) && data.offers && data.offers.length > 0) {
                        const mappedOffers = data.offers.map(o => ({
                            value: o,
                        }));
                        if (data.replaceOffers) {
                            dynamicOffer = mappedOffers;
                        } else {
                            dynamicOffer = dynamicOffer.concat(mappedOffers);
                        }
                    }
                } catch (e) {}

                if (!jTierDis && !showJProm && dynamicOffer.length === 0) return null;

                const specialofferProps = { dynamicOffer, jTierDis, jPromMsg, showJProm, product };

                let childComponent = children ? (
                    children({ offers: dynamicOffer })
                ) : (
                    <SpecialOfferWithTooltip {...specialofferProps} />
                );

                return withToolTip ? <Tooltip label="See all offers">{childComponent}</Tooltip> : childComponent;
            }}
        </ABTest>
    );
};

class SpecialOfferWithTooltip extends React.Component {
    onBlur = e => {
        const { closeToolTip } = this.props;
        if (!e.target.nextSibling && closeToolTip) {
            closeToolTip();
        }
    };

    render() {
        const { showTooltip, dynamicOffer, jTierDis, jPromMsg, showJProm, product } = this.props;

        return (
            <ul className="offers-list" onBlur={this.onBlur}>
                {dynamicOffer.map((offer, i) => {
                    let className = 'offer-li ' + (offer.type == 'jPromMsg' ? 'j-promo-msg' : '');

                    // TODO: check with andrew
                    if ((offer.value === jPromMsg && showJProm) || offer.value === '') return null;

                    return (
                        <li
                            tabIndex={showTooltip ? 0 : -1}
                            aria-label={offer.value}
                            key={i}
                            className={className}
                            dangerouslySetInnerHTML={Helpers.createMarkup(offer.value)}
                        />
                    );
                })}
                {showJProm && jPromMsg ? (
                    <li
                        tabIndex={showTooltip ? 0 : -1}
                        aria-label={jPromMsg}
                        key={`jPromMsg-${product.sku}`}
                        className="offer-li j-promo-msg"
                    >
                        {jPromMsg}
                    </li>
                ) : null}
                {jTierDis ? (
                    <li
                        tabIndex={showTooltip ? 0 : -1}
                        aria-label={jTierDis}
                        key={`jTier-${product.sku}`}
                        className="offer-li"
                    >
                        {`Tier Discount $${jTierDis}`}
                    </li>
                ) : null}
            </ul>
        );
    }
}

export default withError(withProductPrice(SpecialOffers));
